






















import { Component, Vue } from "vue-property-decorator";
import InviteCard from "@/components/InviteCard.vue";
import config from '../assets/js/config';

@Component({
  components: {
    InviteCard,
  }
})
export default class Share extends Vue{
  inviteCode: string = "______";
  copyStatus: string = 'no';

  mounted() {
    let self = this;
    let urlObj:any = new URL(window.location.href);
    let urlArr: any[] = urlObj.hash.split('?');
    let hashStr: string = '';
    let hashArr: string[] = [];

    this.$as.send('loaded_page_Share')
    if(urlArr.length > 1) {
      hashStr = urlArr[urlArr.length - 1];
      hashArr = hashStr.split('=');

      if(hashArr.length > 1) {
        self.inviteCode = hashArr[hashArr.length - 1]
        this.autoInstall();
      }
    }
  }

  copyCode() {
    let self = this;
    let codeEl:any = document.getElementById('inviteVal');

    this.$as.send('click_copy_btn_Share')
    if(codeEl) {
      if(self.inviteCode && self.inviteCode.length >= 6) {
        try{
          codeEl.select();
          if(document.execCommand('copy', false, '')) {
            self.copyStatus = 'success';
          }else{
            self.copyStatus = 'fail';
          }
        }catch(e){
          self.copyStatus = 'fail';
        }
      }else{
        self.copyStatus = 'fail';
      }
    }
  }

  installXender() {
    this.$as.send('click_install_btn_Share')
    window.location.href = config.downloadUrl;
  }

  autoInstall() {
    this.$as.send('auto_install_Share')
    window.location.href = config.downloadUrl;
  }
}
